import { useEffect, useState } from 'react';
import { assets } from '../assets/assets';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);
  const location = useLocation();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isCareerHovered, setIsCareerHovered] = useState(false);

  const currentYear = new Date().getFullYear();
  const capitalize = (str) => {
    return str
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Update the screen size detection on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024); // Adjust 1024px breakpoint as needed
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showMobileMenu ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showMobileMenu]);

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 10,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 24px',
          maxWidth: '1200px',
          margin: '0 auto',
          backgroundColor: 'transparent',
        }}
      >
        <Link to="/">
          <img
            src={assets.top_logo}
            alt="Logo"
            style={{ width: isDesktop ? '96px' : '50px', cursor: 'pointer' }}
          />
        </Link>

        {/* Only show this on desktop screens */}
        {isDesktop && (
          <ul
            style={{
              display: 'flex',
              gap: '28px',
              backgroundColor: 'white',
              padding: '8px 24px',
              borderRadius: '999px',
              boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
            }}
          >
            {['/', '/about', '/contact', '/products', '/fabrics'].map(
              (path, index) => (
                <Link
                  key={index}
                  to={path}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '999px',
                    color:
                      location.pathname === path
                        ? 'white'
                        : hoveredIndex === index
                        ? '#6b7280' // gray-500 on hover
                        : '#801001',
                    backgroundColor:
                      location.pathname === path ? '#801001' : 'transparent',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease',
                    cursor: 'pointer',
                  }}
                >
                  {path === '/' ? 'Home' : capitalize(path.slice(1))}
                </Link>
              )
            )}
          </ul>
        )}

        {/* Only show this on desktop screens */}
        {isDesktop && (
          <Link to="/career">
            <button
              onMouseEnter={() => setIsCareerHovered(true)}
              onMouseLeave={() => setIsCareerHovered(false)}
              style={{
                backgroundColor: 'white',
                padding: '8px 32px',
                borderRadius: '999px',
                color: isCareerHovered ? '#6b7280' : '#801001', // text color only
                cursor: 'pointer',
                border: 'none',
                transition: 'color 0.3s ease',
              }}
            >
              Careers
            </button>
          </Link>
        )}

        {/* Menu Icon for Mobile View */}
        {!isDesktop && (
          <img
            onClick={() => setShowMobileMenu(true)}
            src={assets.menu}
            style={{ width: '36px', cursor: 'pointer' }}
            alt="Menu"
          />
        )}
      </div>

      {/* Backdrop for Mobile Menu */}
      {showMobileMenu && (
        <div
          onClick={() => setShowMobileMenu(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            zIndex: 9998,
            backdropFilter: 'blur(2px)',
          }}
        />
      )}

      {/* Mobile Fullscreen Menu */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '75%',
          height: '80vh',
          background: '#FFE6E6',
          color: '#801001',
          transform: showMobileMenu ? 'translateY(0)' : 'translateY(-100%)',
          opacity: showMobileMenu ? 1 : 0,
          transition: 'transform 0.4s ease, opacity 0.3s ease',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          padding: '16px',
          boxSizing: 'border-box',
          WebkitTransform: showMobileMenu
            ? 'translateY(0)'
            : 'translateY(-100%)', // iOS/Chrome smoothness
          willChange: 'transform, opacity',
        }}
      >
        {/* Header with Logo and Close Icon */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0, // don’t shrink
            marginBottom: '16px',
          }}
        >
          <img
            src={assets.top_logo}
            alt="Logo"
            style={{ width: '50px', position: 'relative', top: -15 }}
          />
          <img
            onClick={() => setShowMobileMenu(false)}
            src={assets.cross}
            style={{ width: '28px', cursor: 'pointer' }}
            alt="Close"
          />
        </div>

        {/* Links List */}
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            flex: 1, // take remaining space
            overflowY: 'auto', // scroll links if too many
          }}
        >
          {['/', '/about', '/contact', '/products', '/fabrics', '/career'].map(
            (path, index) => (
              <li
                key={index}
                style={{
                  borderBottom: '1px solid #ccc',
                  marginBottom: '8px',
                  flexShrink: 0,
                }}
              >
                <Link
                  to={path}
                  onClick={() => setShowMobileMenu(false)}
                  style={{
                    display: 'block',
                    padding: '12px 0',
                    color: '#801001',
                    fontWeight: 600,
                    textDecoration: 'none',
                  }}
                >
                  {path === '/' ? 'Home' : capitalize(path.slice(1))}
                </Link>
              </li>
            )
          )}
        </ul>

        {/* Footer */}
        <div
          style={{
            textAlign: 'center',
            padding: '8px 0',
            fontSize: '13px',
            color: '#666565',
            flexShrink: 0, // keep footer visible
          }}
        >
          © {currentYear} Kobithan Garments (Pvt) Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Navbar;
